<template>
  <div>
    <!--GERAR CONSULTA EM LOTE-->
    <ed-modal
      :modal="showModal"
      title="Formulário de Cadasto de Consulta em Lote"
      width="99%"
      :onSave="salvar"
      :onClose="fechar"
    >
      <div slot="modal-content" v-if="formData.data_age">
        <ed-form :model="formData">
          <div
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 item-group text-left pa-0"
          >
            Selecione o(s) Trabalhador(es)
          </div>

          <ed-input-auto-complete
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pa-0"
            label="Trabalhadores"
            placeholder="Digite o nome do trabalhador(a)"
            v-model="formData.funcionario"
            :items="list.funcionario"
            :loading="loadingFuncionario"
            @search="getFuncionario"
            @input="formatarFuncionario(formData.funcionario)"
            clearable
            required
            is-object
          />

          <ed-input-date
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
            label="Data do Agendamento da Consulta"
            v-model="formData.data_age"
            info="A data do agendamento não garante horário disponível. A disponibilidade deve ser confirmado no dia da consulta diretamente com a clínica que realizará a consulta."
            :disabled="!formData.funcionarios.length"
            yesterdayDisabled
            tomorrowDisabled
          />

          <ed-input-text
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
            label="Observações"
            type="textarea"
            v-model="formData.obs"
            :disabled="!formData.funcionarios.length"
          />

          <div
            v-if="formData.funcionarios.length"
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 item-group text-left pa-0"
          >
            Informações da Consulta
          </div>

          <div class="col-md-12 text-left" v-if="formData.funcionarios.length">
            <b-table-simple hover small caption-top responsive>
              <b-thead head-variant="light" class="table-v2">
                <b-tr>
                  <b-th>Trabalhador</b-th>
                  <b-th>Função</b-th>
                  <b-th>Frente de Trabalho</b-th>
                  <b-th>GHE (Setor)</b-th>
                  <b-th>Tipo de Consulta</b-th>
                  <b-th>Remover</b-th>
                  <!-- <b-th>Valor</b-th>
                          <b-th>Exames</b-th>-->
                </b-tr>
              </b-thead>
              <b-tbody>
                <b-tr
                  v-for="(funcionario, index) in formData.funcionarios"
                  :key="index"
                >
                  <b-td style="text-transform: uppercase; font-size: 8pt">{{
                    funcionario.nome
                  }}
                  <span v-if="getError(funcionario)" style="color:red;font-size:7pt">
                    <br>
                    {{getError(funcionario)}}
                  </span>
                  
                  </b-td>

                  <b-td style="text-transform: uppercase; font-size: 8pt">{{
                    funcionario.funcao ? funcionario.funcao.nome : "---"
                  }}</b-td>

                  <b-td style="text-transform: uppercase; font-size: 8pt">{{
                    funcionario.fdt && funcionario.fdt.pcmso
                      ? funcionario.fdt.pcmso +
                        " (" +
                        funcionario.fdt.descricao +
                        ")"
                      : "---"
                  }}</b-td>

                  <b-td style="text-transform: uppercase; font-size: 8pt">{{
                    funcionario.ghe && funcionario.ghe.ghe
                      ? funcionario.ghe.ghe +
                        " (" +
                        funcionario.ghe.descricao +
                        ")"
                      : "---"
                  }}</b-td>

                  <b-td style="text-transform: uppercase; font-size: 8pt">
                    <el-collapse
                      title="Clique para mostrar mais informações"
                      v-model="funcionario.collapse"
                    >
                      <el-collapse-item :name="index.toString()">
                        <template slot="title">
                          <i
                            class="fa fa-minus-circle fa-1x mr-1"
                            style="color: #28a745"
                            v-if="
                              funcionario.collapse && funcionario.collapse[0]
                            "
                          />
                          <i
                            class="fa fa-plus-circle fa-1x mr-1"
                            style="color: #28a745"
                            v-else
                          />
                          {{ formatarTipoConsulta(funcionario) }}
                        </template>

                        <ed-input-select-tipo
                          class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
                          :name="'id_tipo_aso_' + index"
                          :key="index"
                          tipo="46"
                          v-model="funcionario.id_tipo_aso"
                          isRadio
                          required
                        >
                          <div
                            :slot="'id_tipo_aso_' + index + '_50'"
                            class="pb-1"
                            v-if="funcionario.id_tipo_aso == 50"
                          >
                            <div class="row ml-0 mr-0 mb-0">
                              <ed-input-select
                                class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
                                label="Nova Frente de Trabalho"
                                v-model="funcionario.id_mf_fdt"
                                :items="list.fdt"
                                :loading="loadingFdt"
                                itemText="fdt"
                                @input="getGhe(funcionario)"
                                required
                              />

                              <ed-input-select
                                class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
                                label="Novo GHE (Setor)"
                                v-model="funcionario.id_mf_ghe"
                                :items="list.ghe"
                                :loading="loadingGhe"
                                :disabled="!funcionario.id_mf_fdt"
                                @input="getFuncao(funcionario)"
                                itemGroup
                                required
                              />

                              <ed-input-select
                                class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
                                label="Nova Função"
                                v-model="funcionario.id_mf_funcao"
                                :items="list.funcao"
                                :loading="loadingFuncao"
                                :disabled="
                                  !funcionario.id_mf_fdt ||
                                  !funcionario.id_mf_ghe
                                "
                                required
                              />
                            </div>
                          </div>

                          <div
                            :slot="
                              'id_tipo_aso_' +
                              index +
                              '_' +
                              funcionario.id_tipo_aso
                            "
                            class="pb-1"
                            v-if="
                              funcionario.id_tipo_aso == 52 ||
                              funcionario.id_tipo_aso == 48
                            "
                          >
                            <ed-input-select
                              class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
                              label="Periodicidade"
                              v-model="funcionario.periodicidade"
                              :items="listaPeriodicidade(funcionario)"
                              required
                            />
                          </div>
                        </ed-input-select-tipo>
                      </el-collapse-item>
                    </el-collapse>
                  </b-td>
                  <b-td style="text-transform: uppercase; font-size: 8pt">
                    <ed-button
                      icon="fa fa-trash"
                      type="danger"
                      size="mini"
                      @click="onDelete(funcionario)"
                    />
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
        </ed-form>
      </div>
    </ed-modal>
  </div>
</template>

<script>
import EdTable from "common/table";

import {
  EdForm,
  EdAlert,
  EdButton,
  EdModal,
  EdInputText,
  EdInputDate,
  EdInputAutoComplete,
  EdInputSelect,
  EdInputSelectTipo,
} from "template";

export default {
  name: "EmpresaCadastro",
  components: {
    EdTable,
    EdForm,
    EdModal,
    EdAlert,
    EdButton,
    EdInputText,
    EdInputDate,
    EdInputAutoComplete,
    EdInputSelect,
    EdInputSelectTipo,
  },
  mixins: [],
  props: {
    showLote: {
      type: Boolean,
      default: false,
    },
    parent: {
      type: Object,
      default: null,
    },
    funcionario: {
      type: Array,
      default: null,
    },
    tipoAso: {
      type: [String, Number],
      default: 52,
    },
    callback: {
      type: Function,
      default: null,
    },
  },
  watch: {
    parent() {},
    funcionario() {},
    tipoAso() {},
    showLote() {
      this.showModal = !this.showModal;
      this.inicialize();
    },
    "$root.$session.event"() {
      this.$forceUpdate();
    },
    formData: {
      handler: function (newVal) {},
      deep: true,
    },
  },
  computed: {
    listaPeriodicidade() {
      return (funcionario) => {
        if (funcionario.id_tipo_aso == 48) {
          funcionario.periodicidade = 6;
          return [{ id: 6, nome: "6 meses" }];
        }

        funcionario.periodicidade = 12;

        return [
          { id: 6, nome: "6 meses" },
          { id: 12, nome: "12 meses" },
        ];
      };
    },

    disabilitarConsulta() {
      return (item, funcionario) => {
        switch (item.id) {
          case 47:
            return (
              this.formData.funcionario && this.formData.funcionario.adm == 1
            );
            break;

          case 48:
            return (
              this.formData.funcionario &&
              this.formData.funcionario.apos_adm == 1
            );
            break;

          case 51:
            return (
              this.formData.funcionario && this.formData.funcionario.dem == 1
            );
            break;

          default:
            return false;
            break;
        }
      };
    },
  },
  data() {
    return {
      showModal: false,
      tabSelected: "tab-guia",
      response: {},
      formDataItems: [],
      list: {
        fdt: [],
        ghe: [],
        mf_ghe: [],
        mf_funcao: [],
        funcao: [],
        funcionario: [],
      },
      formData: {
        funcionario: null,
      },
      loadingFuncionario: false,
      loadingFdt: false,
      loadingGhe: false,
      loadingFuncao: false,
    };
  },

  beforeDestroy() {},

  created() {},
  mounted() {
    this.getFuncionario();
    this.getFDT();
  },

  methods: {

    getError(funcionario){
      if(this.$root.$request.dados && this.$root.$request.dados.options && this.$root.$request.dados.options.data && this.$root.$request.dados.options.data[funcionario.id]){
        return this.$root.$request.dados.options.data[funcionario.id].join('<br>')
      }

      return null;
    },

    formatarFuncionario(_funcionario,_id_tipo_aso) {
      if (
        _funcionario &&
        !this.$utilidade.arrFindByField(
          this.formData.funcionarios,
          "id",
          _funcionario.id
        )
      ) {
        let funcionario = Object.assign(_funcionario, {});

        if (!funcionario.id_tipo_aso) {
          funcionario.id_tipo_aso = (_id_tipo_aso ? _id_tipo_aso : 52);
          funcionario.id_mf_fdt = null;
          funcionario.id_mf_ghe = null;
          funcionario.id_mf_funcao = null;
        }
        this.formData.funcionarios.push(funcionario);
      }
      this.formData.funcionario = null;
    },

    formatarTipoConsulta(funcionario) {
      let aso = "SELECIONE";

      switch (funcionario.id_tipo_aso) {
        case 47:
          aso = "ADMISSIONAL";
          break;

        case 48:
          aso = "APÓS ADMISSIONAL";
          break;

        case 49:
          aso = "RETORNO AO TRABALHO";
          break;

        case 50:
          aso = "MUDANÇA DE FUNÇÃO";
          break;

        case 51:
          aso = "DEMISSIONAL";
          break;

        case 52:
          aso =
            "PERIÓDICO" +
            (funcionario.periodicidade
              ? " " + funcionario.periodicidade + " MESES"
              : "");
          break;
      }

      return (
        aso +
        (funcionario.periodicidade
          ? " " + funcionario.periodicidade + " MESES"
          : "")
      );
    },

    inicialize() {
      this.formData = {
        id: 0,
        data_age: this.$utilidade.toDate(null, true),
        funcionarios: [],
        tabela_preco: null,
        obs: null,
      };
      this.list.funcionario = [];

      if (this.funcionario && this.funcionario.length > 0) {
        let self = this;
        this.funcionario.forEach(function (funcionario) {
          self.formatarFuncionario(funcionario,self.tipoAso)
        });
      }
    },

    onDelete(funcionario) {
      var element = this.$utilidade.arrFindByField(
        this.formData.funcionarios,
        "id",
        funcionario.id
      );

      for (let i = 0; i < this.formData.funcionarios.length; i++) {
        const element = this.formData.funcionarios[i];

        if (element.id == funcionario.id) {
          this.formData.funcionarios.splice(i, 1);
        }
      }
    },

    getFuncionario(_search) {
      this.loadingFuncionario = true;
      this.list.funcionario = [];

      this.$root.$request
        .get("funcionario/0", { search: _search, pagination: 100 })
        .then((result) => {
          this.loadingFuncionario = false;

          if (result.status == 200) {
            this.list.funcionario = result.data.data;
          }
        });
    },

    getFDT() {
      this.loadingFdt = true;
      this.list.fdt = [];

      this.$root.$request.get("pcmso/fdt").then((result) => {
        this.loadingFdt = false;

        if (result.status == 200) {
          this.list.fdt = result.data.data;
        }
      });
    },

    getGhe(funcionario) {
      this.loadingGhe = true;
      this.ghe = [];

      this.formData.id_mf_ghe = null;

      var filter = {
        id_fdt: funcionario.id_mf_fdt,
      };

      this.$root.$request
        .get("pcmso/ghe", {
          filter: filter,
          pagination: 100,
        })
        .then((result) => {
          this.loadingGhe = false;

          if (result.status == 200) {
            this.list.ghe = result.data;
          }
        });
    },

    getFuncao(funcionario) {
      this.loadingFuncao = true;
      this.list.funcao = [];

      funcionario.id_mf_funcao = null;

      var filter = {
        id_fdt: funcionario.id_mf_fdt,
      };

      this.$root.$request
        .get("pcmso/ghe/funcao/" + funcionario.id_mf_ghe, {
          filter: filter,
          pagination: 1000,
        })
        .then((result) => {
          this.loadingFuncao = false;

          if (result.status == 200) {
            this.list.funcao = result.data.data;
          }
        });
    },

    fechar() {
      this.formDataItems = [];
      if (this.callback) this.callback();
    },

    salvar() {
      this.$root.$loading.set(true);

      this.$root.$request.post("consulta/externa/lote", this.formData).then((result) => {
        this.$root.$loading.set(false);

        console.log(result)
        if (result.status == 200) {
          this.showModal = !this.showModal;

          if (this.parent) {
            this.parent.getConsulta();
          }

          this.$root.$dialog.alert(
            "Consulta registrada com sucesso. Agora você deve aguardar enquanto o sistema processa a solicitação em segundo plano. Espere alguns minutos e atualize essa página para verificar o andamento da solicitação."
          );
        }
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// lote.vue?d91a65d0